import { HomePasteTable } from './HomePasteTable';
export default HomePasteTable;
